import { getGoogleRecaptchaSiteKey } from '../selectors/global';

export const requestCaptchaToken = async (state, action) => {
  const siteKey = getGoogleRecaptchaSiteKey(state);

  await new Promise(resolve => {
    window.grecaptcha.ready(resolve);
  });

  return window.grecaptcha.execute(siteKey, { action });
};
